import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import GetQualityColumnClass from './GetQualityColumnClass';
import LabDetailsDialog from '../../../../Dialogs/LabDetailsDialog';
import { Quality, QualityValue, QualityValueSample, QualityColumnType } from '../../../../Types/LotDetailQuality';

export interface LBMLabCellProps {
    quality: Quality,
    qualityType: string,
    qualityColumns: QualityColumnType[]
}

function LBMLabCell({ quality, qualityType, qualityColumns }: LBMLabCellProps): React.JSX.Element {
    const [showLabDetails, setShowLabDetails] = useState(false);

    let samples: QualityValueSample[] = [];
    let value  = "";
    let comment = "";
    let className = "";

    quality.qualityValues.forEach(function (qualityValue: QualityValue) {
        if (qualityValue.testMethod === qualityType) {
            samples = qualityValue.qualityValueSamples;
            value = qualityValue.resultValue + " (" + samples.length + ")";
            comment = samples.reduce<string>((accumulator, currentValue) => {
                if (accumulator === '') {
                    return currentValue.comment; // First element, no separator needed
                }
                if (currentValue.comment === null || currentValue.comment === "") {
                    return accumulator;
                }
                return `${accumulator}, ${currentValue.comment}`;
            }, '');
            className = GetQualityColumnClass(qualityValue) + " lab";
        }
    });

    const ValueContent = () => {
        return (
            (comment === null || comment === "")
                ? <Button variant="link" className={'quality-value-column link ' + className} onClick={() => setShowLabDetails(true)}>{value}</Button>
                :
                <OverlayTrigger
                    overlay={
                        <Tooltip>
                            {comment}
                        </Tooltip>
                    }
                >
                    <Button variant="link" className={'quality-value-column link ' + className} onClick={() => setShowLabDetails(true)}>{value}</Button>
                </OverlayTrigger>
        );
    }

    return (
        <>
            <ValueContent></ValueContent>
            <LabDetailsDialog showDialog={showLabDetails} closeDialog={() => setShowLabDetails(false)} quality={quality} samples={samples} qualityColumns={qualityColumns} />
        </>
    );
}

export default LBMLabCell;